import { gql } from "@apollo/client"

export const GET_WHW_AWARDS = gql`
  query {
    awards {
      name
      label
    }
  }
`
